/*
 * results Reducer
 */
import { SET_RESULT } from './constants';

const initialState = {};

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_RESULT:
            return {
                ...state,
                [action.namespace]: action.result
            };
        default:
            return state;
    }
}
